/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { Button } from "@material-ui/core";
import { useLocation, useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import Header from "./headerPhase2";
import { Helmet } from "react-helmet";
import { Carousel } from "antd";
import backArrow from "./../assets/img/back-arrow.svg";
import redoBtn from "./../assets/img/redo-btn.svg";
import { bindActionCreators } from "redux";
import { actionCreators } from "../state";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Spin } from "antd";
import errorImage from "./../assets/img/error-image.svg";
import { LoadingOutlined } from "@ant-design/icons";
import Checkbox from "@mui/material/Checkbox";
import { resources } from "../resource";

import moment from "moment";
import { formatErrorMessage } from "../utils/errorHandler";
import { logError } from "../utils/logger";
import axios from "axios";

const Signature = (props) => {

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;

  // Redux
  const dispatch = useDispatch();
  const actions = bindActionCreators(actionCreators, dispatch);

  // Navigation
  const navigate = useNavigate();

  // Refs
  const sigCanvas = useRef(null);

  const sessionId = useSelector((store) => store.auth.sessionId);
  const patientForm = useSelector((state) => state.patientForm);
  const clinicUrl = useSelector((state) => state.auth.clinicUrl);
  const formTranslations = useSelector(
    (state) => state.formTranslations.translations
  );

  const _resources = resources[props.language];

  // Form Data
  const initialFormData = Object.freeze({
    AnythingChangeInHealthYourLastAppointment: null,
    InsuranceChangeSinceLastAppointment: null,
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
  });
  const [formData, updateFormData] = useState(initialFormData);
  const [validationErrors, setValidationErrors] = useState([]);

  const [signature, setSignature] = useState(null);
  const [hasSignature, setHasSignature] = useState(false);
  const saveSignature = () => {
    if (sigCanvas.current) {
      setSignature(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    }
  };

  const [receiptAcknowledgement, setReceiptAcknowledgement] = useState(false);
  const [treatmentAcknowledgement, setTreatmentAcknowledgement] = useState(false);
  const [actionAcknowledgement, setActionAcknowledgement] = useState(false);
  const [financialAcknowledgement, setFinancialAcknowledgement] = useState(false);
  const [termsCons, setTermsCon] = useState(false);
  const [privacyPol, setPrivacyPol] = useState(false);

  // Status Flags
  const [updatePatientSpinner, setUpdatePatientSpinner] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState(false);

  useEffect(() => {
    const fetchTermsData = async () => {
      try {
        const response = await axios.get(
          `${API_URL}Settings/GetFormContentTerms`,
        );
        actions.setTranslations(response.data.formTranslationContents);
      } catch (err) {
        console.error(err);
      }
    };
    if (formTranslations.length == 0) {
      fetchTermsData();
    }
  }, []);

  const {
    firstName,
    lastName,
    preferredName,
    heightFt,
    heightIn,
    weight,
    address1,
    address2,
    city,
    state,
    zip,
    dob,
    email,
    hearAbout,
    referredByName,
    referredByPhone,
    primaryCarePhysicianFirstName,
    primaryCarePhysicianLastName,
    primaryCarePhysicianPhone,
    emergencyContactFirstName,
    emergencyContactLastName,
    emergencyContactRelationship,
    emergencyContactPhone,
    hasMedicalInsurance,
    employerName,
    employerPhone,
    employerAddress1,
    employerAddress2,
    employerCity,
    employerState,
    employerZip,
    job,
    jobStatus,
    autoInsuranceCompany,
    AutoInsuranceCompanyPhoneNumber,
    autoAttorneyFirstName,
    autoAttorneyLastName,
    autoHealthInsurancePhone,
    autoHealthInsuranceCompany,
    autoAttorneyPhone,
    autoAccidentPhone,
    autoAccidentPrimaryInsuredName,
    autoIDNumber,
    isAutoInjury,
    isWorkInjury,
    letterOfExhaustionFromYourAutoCarrier,
  } = patientForm.patientForm;

  const { extension, imageUrl } = patientForm.letterOfExhaustionCopy;

  const {
    medicalIllnessesHeartProblems,
    medicalIllnessesPregnant,
    medicalIllnessesCancer,
    medicalIllnessesPaceMakers,
    medicalIllnessesOsteoporosis,
    medicalIllnessesDiabetes,
    medicalIllnessesAsthma,
    medicalIllnessesStroke,
    medicalIllnessesHighBloodPressure,
    medicalIllnessesSmoking,
    medicalIllnessesSeizures,
    medicalIllnessesHivAids,
    medications,
    doHaveAnyAllergy,
    allergies,
    chiefPhysicalComplaint,
    howItHappened,
    surgeryInjuryLast5,
    // previousTherapy: havePreviousTherapyForTheProblem,
    havePreviousTherapyForTheProblem,
    wasPreviousTherapyHelpful,
  } = patientForm.medicalForm;

  const {
    physicalOccupationalSpeechThreapy,
    woundCare,
    injectionsMedications,
    bathingPersonalCare,
    ivCare,
    homeHealthRepresentativeNursAide,
  } = patientForm.medicareForm;

  var url, clinicId;
  if (patientForm.clinicName.includes("/patient-checkin/checkin?clinicId=")) {
    if (patientForm.clinicName !== "") {
      url = new URL(patientForm.clinicName);
      clinicId = url.searchParams.get("clinicId").replaceAll("%20", " ");
    }
  } else {
    clinicId = patientForm.clinicName.replaceAll("%20", " ");
  }

  const location = useLocation();

  useEffect(() => {
    if (location.state == null) {
      window.location.replace(clinicUrl);
    }
    window.history.replaceState(null, "");
  }, []);

  function customSerialize(obj) {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    });
  }

  const handleClick = async () => {
    // let encodedSignature = await toBase64(canvasRef._sigPad);
    // let customizedObj = customSerialize(canvasRef);

    // actions.saveSignature(customizedObj);

    try {
      if (patientForm.updateEditButtonForNewPatient) {
        submitForNewPatient();
      } else if (patientForm.updateEditButtonForExistingPatient) {
        submitForExistingPatient();
      }
    } catch (error) {
      logActivity(
        error,
        "signature.handleClick",
        "Error while clicking the submit signature button",
      );
      setApiErrorMessage(true);
      setUpdatePatientSpinner(false);
    }
  };

  const logActivity = async (error, source, message) => {
    const errorMessage = formatErrorMessage(error);
    await logError({
      source: source,
      message: message,
      exception: errorMessage,
      sessionID: sessionId,
    });
  };

  const redoButtonClear = () => {
    setHasSignature(false);
    if (sigCanvas.current) {
      sigCanvas.current.clear();
      setSignature(null);
    }
  };

  const submitForNewPatient = async () => {
    
    try {
      const responseIP = await fetch("https://api.ipify.org/?format=json");
      const ipAddress = await responseIP.json();

      const controller = new AbortController();
      const id = setTimeout(
        () => controller.abort(),
        process.env.REACT_APP_API_TIMEOUT,
      );

      setUpdatePatientSpinner(true);
      let bodyArry = {
        address1: address1,
        address2: address2,
        allergies: allergies,
        anyServicesNotListedAbove: false,
        appointmentId:
          Object.keys(patientForm.validationResponse).length !== 0
            ? patientForm.validationResponse.appointmentId
            : null,
        attorneyAreaCode: autoAttorneyPhone?.slice(1, 4),
        attorneyPhone: autoAttorneyPhone?.slice(6, 16).replaceAll("-", ""),
        autoAccidentPrimaryInsuredName: autoAccidentPrimaryInsuredName,
        AutoInsuranceAreaCode: AutoInsuranceCompanyPhoneNumber
          ? AutoInsuranceCompanyPhoneNumber?.slice(1, 4)
          : "",
        autoAttorneyFirstName: autoAttorneyFirstName,
        autoAttorneyLastName: autoAttorneyLastName,
        autoAttorneyPhone: autoAttorneyPhone,
        AutoInsurancePhone: AutoInsuranceCompanyPhoneNumber
          ? AutoInsuranceCompanyPhoneNumber?.slice(6, 16).replaceAll("-", "")
          : "",
        autoHealthInsuranceAreaCode: autoHealthInsurancePhone?.slice(1, 4),
        autoHealthInsuranceCompany: autoHealthInsuranceCompany,
        autoHealthInsurancePhone: autoHealthInsurancePhone
          ?.slice(6, 16)
          .replaceAll("-", ""),
        autoIDNumber: autoIDNumber,
        autoInsuranceCompany: autoInsuranceCompany,
        bathingPersonalCare:
          bathingPersonalCare === null ? false : bathingPersonalCare,
        chiefPhysicalComplaint: chiefPhysicalComplaint,
        city: city,
        companyId: Object.keys(patientForm.patientForm).includes("companyId")
          ? patientForm.patientForm.companyId
          : patientForm.newPatientValidation.companyId,
        consentedToAI: patientForm.patientForm.consentedToAI,
        dob: moment(dob).format("YYYY-MM-DD"),
        doHaveAnAllergy: doHaveAnyAllergy,
        email: patientForm.patientForm.email2
          ? patientForm.patientForm.email2
          : email,
        emergencyContactAreaCode:
          emergencyContactPhone && emergencyContactPhone?.slice(1, 4),
        emergencyContactFirstName: emergencyContactFirstName,
        emergencyContactLastName: emergencyContactLastName,
        emergencyContactPhone:
          emergencyContactPhone &&
          emergencyContactPhone?.slice(6, 16).replaceAll("-", ""),
        emergencyContactRelationship: emergencyContactRelationship,
        employerAddress1: employerAddress1,
        employerAddress2: employerAddress2,
        employerAreaCode: employerPhone && employerPhone?.slice(1, 4),
        employerCity: employerCity,
        employerName: employerName,
        employerPhone:
          employerPhone && employerPhone?.slice(6, 16).replaceAll("-", ""),
        employerState: employerState,
        employerZip: employerZip,
        firstName: firstName,
        gender: patientForm.patientForm.gender,
        guardianCompletedForms: patientForm.patientForm.guardianCompletedForms,
        guardianFirstName: patientForm.patientForm.guardianFirstName == "" ? null :patientForm.patientForm.guardianFirstName,
        guardianLastName: patientForm.patientForm.guardianLastName == "" ? null :patientForm.patientForm.guardianLastName,
        guardianRelationship: patientForm.patientForm.guardianRelationship == "" ? null :patientForm.patientForm.guardianRelationship,
        hasMedicalInsurance: hasMedicalInsurance ? true : false,
        havePreviousTherapyForTheProblem:
          havePreviousTherapyForTheProblem === null
            ? false
            : havePreviousTherapyForTheProblem,
        hearAbout: hearAbout,
        heightFt:
          heightFt == null || heightFt == "" || heightFt?.trim() != heightFt
            ? 0
            : Number(heightFt),
        heightIn:
          heightIn == null || heightIn == "" || heightIn?.trim() != heightIn
            ? 0
            : Number(heightIn),
        homeHealthRepresentativeNursAide:
          homeHealthRepresentativeNursAide === null
            ? false
            : homeHealthRepresentativeNursAide,
        howItHappened: howItHappened,
        injectionsMedications:
          injectionsMedications === null ? false : injectionsMedications,
        iPAdress: ipAddress.ip,
        isAutoInjury: isAutoInjury === null ? false : isAutoInjury,
        isWorkInjury: isWorkInjury === null ? false : isWorkInjury,
        ivCare: ivCare === null ? false : ivCare,
        job: job,
        jobStatus: jobStatus,
        lastName: lastName,
        letterOfExhaustionFromCopy: imageUrl !== null ? imageUrl : null,
        letterOfExhaustionFromCopyExtension:
          extension !== null ? extension : null,
        letterOfExhaustionFromYourAutoCarrier:
          letterOfExhaustionFromYourAutoCarrier !== null &&
          letterOfExhaustionFromYourAutoCarrier !== "NotSure"
            ? letterOfExhaustionFromYourAutoCarrier
            : false,
        medicalIllnessesAsthma:
          medicalIllnessesAsthma !== null ? medicalIllnessesAsthma : false,
        medicalIllnessesCancer:
          medicalIllnessesCancer !== null ? medicalIllnessesCancer : false,
        medicalIllnessesDiabetes:
          medicalIllnessesDiabetes !== null ? medicalIllnessesDiabetes : false,
        medicalIllnessesHeartProblems:
          medicalIllnessesHeartProblems !== null
            ? medicalIllnessesHeartProblems
            : false,
        medicalIllnessesHighBloodPressure:
          medicalIllnessesHighBloodPressure !== null
            ? medicalIllnessesHighBloodPressure
            : false,
        medicalIllnessesHivAids:
          medicalIllnessesHivAids !== null ? medicalIllnessesHivAids : false,
        medicalIllnessesOsteoporosis:
          medicalIllnessesOsteoporosis !== null
            ? medicalIllnessesOsteoporosis
            : false,
        medicalIllnessesPaceMakers:
          medicalIllnessesPaceMakers !== null
            ? medicalIllnessesPaceMakers
            : false,
        medicalIllnessesPregnant:
          medicalIllnessesPregnant !== null ? medicalIllnessesPregnant : false,
        medicalIllnessesSeizures:
          medicalIllnessesSeizures !== null ? medicalIllnessesSeizures : false,
        medicalIllnessesSmoking:
          medicalIllnessesSmoking !== null ? medicalIllnessesSmoking : false,
        medicalIllnessesStroke:
          medicalIllnessesStroke !== null ? medicalIllnessesStroke : false,
        medications: medications,
        mobileAreaCode: Object.keys(patientForm.patientForm).includes("phone")
          ? patientForm.patientForm.phone.slice(1, 4)
          : patientForm.patientForm.mobilePhone.slice(1, 4),
        mobilePhone: Object.keys(patientForm.patientForm).includes("phone")
          ? patientForm.patientForm.phone.slice(6, 15).replaceAll("-", "")
          : patientForm.patientForm.mobilePhone
              .slice(6, 15)
              .replaceAll("-", ""),
        patientId: Object.keys(patientForm.patientForm).includes("patientId")
          ? patientForm.patientForm.patientId
          : patientForm.newPatientValidation.patientId,
        physicalOccupationalSpeechThreapy:
          physicalOccupationalSpeechThreapy === null
            ? false
            : physicalOccupationalSpeechThreapy,
        preferredName: preferredName,
        primaryCarePhysicianAreaCode:
          primaryCarePhysicianPhone && primaryCarePhysicianPhone?.slice(1, 4),
        primaryCarePhysicianFirstName: primaryCarePhysicianFirstName,
        primaryCarePhysicianLastName: primaryCarePhysicianLastName,
        primaryCarePhysicianPhone:
          primaryCarePhysicianPhone &&
          primaryCarePhysicianPhone?.slice(6, 16).replaceAll("-", ""),
        referredByName: referredByName,
        referrredByAreaCode: referredByPhone?.slice(1, 4),
        referredByPhone: referredByPhone?.slice(6, 16).replaceAll("-", ""),
        signature: signature,
        signatureExtension: "jpeg",
        state: state,
        surgeryInjuryLast5: surgeryInjuryLast5,
        wasPreviousTherapyHelpful:
          wasPreviousTherapyHelpful === null
            ? false
            : wasPreviousTherapyHelpful,
        weight:
          weight == null || weight == "" || weight?.trim() != weight
            ? 0
            : Number(weight),
        woundCare: woundCare === null ? false : woundCare,
        zip: zip,
      };

      for (let i in bodyArry) {
        if (typeof bodyArry[i] === "string") {
          bodyArry[i] = bodyArry[i].replace(/&/g, "and");
        }
      }

      const responseAPI = await fetch(
        `${API_URL}PatientCheckIn/SubmitPatient`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify(bodyArry),
        },
      );
      clearTimeout(id);

      if (responseAPI.ok) {
        await logError({
          source: "signature.submitForNewPatient",
          message: "Success SubmitPatient API Call",
          exception: null,
          sessionID: sessionId,
        });
        const response = await responseAPI.json();
        setUpdatePatientSpinner(false);

        if (response.responseCode === 200 && response.submitPatient.status) {
          const { amountDue, accountNo } = response.submitPatient;

          if (amountDue == 0) {
            navigate("/patient-checkin/form-submitted", {
              state: {
                submitPatientRespone: response.submitPatient,
                newPatient: true,
              },
            });
          } else if (amountDue > 0) {
            navigate("/patient-checkin/amount-due", {
              state: {
                email: patientForm.patientForm.email2
                  ? patientForm.patientForm.email2
                  : email,
                accountNo: accountNo,
                amountDue: amountDue,
              },
            });
          }
        } else {
          logActivity(
            "Response code is not 200",
            `submitForNewPatient ${JSON.stringify(bodyArry)}`,
            "Error in SubmitNewPatient API",
          );
          setApiErrorMessage(true);
          setUpdatePatientSpinner(false);
        }
      } else {
        setUpdatePatientSpinner(false);

        if (responseAPI.status === 400 || responseAPI.status === 500) {
          const response = await responseAPI.json();
          setValidationErrors(response);
        }
      }
    } catch (error) {
      const errorMessage = formatErrorMessage(error);
      await logError({
        urNumber: 0,
        urID: 'System',
        company: 'System',
        message: "/patient-checkin/form-submitted",
        exception: errorMessage,
        sessionID: sessionId,
      });
      setApiErrorMessage(true);
      setUpdatePatientSpinner(false);
    }
  };

  const submitForExistingPatient = async () => {
    const REACT_APP_API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;

    const controller = new AbortController();
    const id = setTimeout(
      () => controller.abort(),
      process.env.REACT_APP_API_TIMEOUT,
    );

    setUpdatePatientSpinner(true);

    let cellAreaCode, cell, signatureDataUrl;

    try {
      // if (canvasRef && typeof canvasRef.toDataURL === 'function') {
      //   signatureDataUrl = canvasRef.toDataURL();
      // } else {
      //   throw new Error("Canvas reference is not valid or toDataURL is not a function.");
      // }

      // Determine cell area code and phone number here
      const phoneField =
        patientForm.patientForm.phone || patientForm.patientForm.mobilePhone;

      if (phoneField.length === 10) {
        cellAreaCode = phoneField.slice(0, 3);
        cell = phoneField.slice(3);
      } else {
        cellAreaCode = phoneField.slice(1, 4);
        cell = phoneField.slice(6, 15).replaceAll("-", "");
      }

      const responseAPI = await fetch(
        `${REACT_APP_API_URL}PatientCheckIn/UpdatePatient`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            appointmentId:
              Object.keys(patientForm.validationResponse).length !== 0
                ? patientForm.validationResponse.appointmentId
                : 0,
            companyId: patientForm.patientForm.companyId,
            consentedToAI: patientForm.validationResponse.isAIConsentRequired ? patientForm.patientForm.consentedToAI : null,
            patientId: patientForm.patientForm.patientId,
            address1: patientForm.patientForm.address1,
            address2: patientForm.patientForm.address2 || "",
            city: patientForm.patientForm.city,
            state: patientForm.patientForm.state,
            zip: patientForm.patientForm.zip,
            mobileAreaCode: cellAreaCode,
            mobilePhone: cell,
            email: patientForm.patientForm.email || "",
            signature: signature,
            signatureExtension: "jpeg",
          }),
          signal: controller.signal,
        },
      );

      clearTimeout(id);

      const response = await responseAPI.json();

      if (response.responseCode === 200) {
        await logError({
          source: "signature.submitForExistingPatient",
          message: "Success UpdatePatient API Call",
          exception: null,
          sessionID: sessionId,
        });

        if (response.updateExistingPatient.status === 1) {
          const { amountDue, accountNo } = response.updateExistingPatient;

          if (amountDue == 0) {
            navigate("/patient-checkin/form-submitted", {
            state: {
              submitPatientRespone: {
                companyId: patientForm.patientForm.companyId,
                patientId: patientForm.patientForm.patientId,
              },
              newPatient: false,
            },
          });
          } else if (amountDue > 0) {
            navigate("/patient-checkin/amount-due", {
              state: {
                email: patientForm.patientForm.email2
                  ? patientForm.patientForm.email2
                  : email,
                accountNo: accountNo,
                amountDue: amountDue,
              },
            });
          }
          
        }
      } else {
        logActivity(
          "Response code is not 200",
          `signature.submitForExistingPatient`,
          "Error in SubmitExistingPatient API",
        );
        setValidationErrors(response);
        setApiErrorMessage(true);
      }
    } catch (error) {
      console.error(error);
      logActivity(
        error,
        `signature.submitForExistingPatient`,
        "Error in SubmitExistingPatient API",
      );
      setApiErrorMessage(true);
    } finally {
      setUpdatePatientSpinner(false);
    }
  };

  const handleCheckbox = (e) => {
    updateFormData({
      ...formData,
      [e.target.name]: e.target.checked,
    });
  };

  const renderCarousel = () => (
    <Carousel>
      {[
        "clinic-pic-one",
        "clinic-pic-two",
        "clinic-pic-three",
        "clinic-pic-four",
      ].map((pic, index) => (
        <div key={index}>
          <div className={pic}></div>
        </div>
      ))}
    </Carousel>
  );

  // canvasRef = patientForm.signature;

  const isContactPhoneRequired =
    Object.values(validationErrors).length > 0 &&
    validationErrors?.EmergencyContactPhone?.some(
      (errorMessage) =>
        errorMessage === "The EmergencyContactPhone field is required.",
    );

  const isContactAreaCodeRequired =
    Object.values(validationErrors).length > 0 &&
    validationErrors?.EmergencyContactAreaCode?.some(
      (errorMessage) =>
        errorMessage === "The EmergencyContactAreaCode field is required.",
    );

  const isContactLastNameRequired =
    Object.values(validationErrors).length > 0 &&
    validationErrors?.EmergencyContactLastName?.some(
      (errorMessage) =>
        errorMessage === "The EmergencyContactLastName field is required.",
    );

  const isContactFirstNameRequired =
    Object.values(validationErrors).length > 0 &&
    validationErrors?.EmergencyContactFirstName?.some(
      (errorMessage) =>
        errorMessage === "The EmergencyContactFirstName field is required.",
    );

  const goBack = () => {
    if (location.state?.fromReview) {
      navigate("/patient-checkin/review-form", { state: { fromFlow: true } });
    } else if (location.state?.fromUpload) {
      navigate("/patient-checkin/patient-form", {
        state: { fromReview: true },
      });
    } else {
      window.history.back();
    }
  };

  const privacyRelease = formTranslations?.find(
    (item) => item.fcname == "PRIVACY_AND_RELEASE_AUTH",
  );
  const privacyReleaseText = privacyRelease
    ? props.language == "en"
      ? privacyRelease?.fcenglish
      : props.language == "spa"
        ? privacyRelease?.fcspanish
        : props.language == "cr"
          ? privacyRelease?.fccreole
          : ""
    : "";

  const authConsent = formTranslations?.find(
    (item) => item.fcname == "AUTH_CONSENT_CARE_TREAT",
  );
  const authConsentText = authConsent
    ? props.language == "en"
      ? authConsent?.fcenglish
      : props.language == "spa"
        ? authConsent?.fcspanish
        : props.language == "cr"
          ? authConsent?.fccreole
          : ""
    : "";

  const causeAction = formTranslations?.find(
    (item) => item.fcname == "CAUSE_OF_ACTION",
  );
  const causeActionText = causeAction
    ? props.language == "en"
      ? causeAction?.fcenglish
      : props.language == "spa"
        ? causeAction?.fcspanish
        : props.language == "cr"
          ? causeAction?.fccreole
          : ""
    : "";

  const financeRes = formTranslations?.find(
    (item) => item.fcname == "FINANCIAL_RESPONSIBILITY",
  );
  const financeResText = financeRes
    ? props.language == "en"
      ? financeRes?.fcenglish
      : props.language == "spa"
        ? financeRes?.fcspanish
        : props.language == "cr"
          ? financeRes?.fccreole
          : ""
    : "";

  const termsCon = formTranslations?.find(
    (item) => item.fcname == "TERMS_AND_CONDITIONS",
  );
  const termsConText = termsCon
    ? props.language == "en"
      ? termsCon?.fcenglish
      : props.language == "spa"
        ? termsCon?.fcspanish
        : props.language == "cr"
          ? termsCon?.fccreole
          : ""
    : "";

  const privacyPolicy = formTranslations?.find(
    (item) => item.fcname == "PRIVACY_POLICY",
  );
  const privacyPolicyText = privacyPolicy
    ? props.language == "en"
      ? privacyPolicy.fcenglish
      : props.language == "spa"
        ? privacyPolicy.fcspanish
        : props.language == "cr"
          ? privacyPolicy.fccreole
          : ""
    : "";

  const isValidationError = Object.keys(patientForm.validationResponse).length !== 0 &&
    !patientForm.validationResponse.preRegistrationComplete;
  
  const isNewPatientError = Object.keys(patientForm.newPatientValidation).length !== 0;

  const isDisabled = isValidationError || isNewPatientError
    ? !formData.checkbox1 || !formData.checkbox2 || !formData.checkbox3 || !signature
    : !signature;

  return (
    <>
      <Modal
        visible={apiErrorMessage}
        className="exception-modal"
        onCancel={() => setApiErrorMessage(false)}
        onOk={() => setApiErrorMessage(false)}
        footer={null}
        centered
      >
        <div className="modal-content">
          <img
            className="error-img"
            src={errorImage}
            alt="Something went wrong."
          />

          {Object.keys(validationErrors).length > 0 ? (
            <p className="exception-modal-text">
              {_resources.Signature.FIELD_REQ}
            </p>
          ) : (
            <span className="exception-modal-text">
              {_resources.Checkin.ERROR}
            </span>
          )}

          {isContactPhoneRequired && (
            <p className="mb-0">Contact phone is required.</p>
          )}
          {isContactAreaCodeRequired && (
            <p className="mb-0">Contact area code is required.</p>
          )}
          {isContactLastNameRequired && (
            <p className="mb-0">Contact last name is required.</p>
          )}
          {isContactFirstNameRequired && (
            <p className="mb-0">Contact first name is required.</p>
          )}
        </div>
      </Modal>
      <Header />
      <Helmet>
        <title>Cora Health | Check-In Signature</title>
      </Helmet>

      <div className="confirm-and-book-appointment checkin-page-carousel d-flex justify-content-between">
        <div className="col-lg-7 signature-data">
          <div className="signature-heading">
            <img
              onClick={goBack}
              className="back-arrow"
              src={backArrow}
              alt="date"
            />
            <p className="signature">{_resources.Signature.SIGNATURE}</p>
          </div>
          {/* <div>
                <p className="required-signature">
                  Signature is required to submit the form
                </p>
              </div> */}
          <div className="signature-canvas">
            <SignatureCanvas
              ref={sigCanvas}
              onEnd={saveSignature}
              onBegin={() => {
                setHasSignature(true);
              }}
              va
              penColor="green"
              // canvasProps={{ width: 300, height: 350, className: "sigCanvas" }}
              canvasProps={{
                // width: 700,
                // height: 350,
                className: "sigCanvas",
              }}
            />
            {!hasSignature && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                {_resources.VerificationOfBenefits.SIGN_HERE}
              </div>
            )}

            <Button className="redo" onClick={redoButtonClear}>
              <img src={redoBtn} alt="date" />
              <span className="ml-2">
                {_resources.VerificationOfBenefits.REDO}
              </span>
            </Button>
          </div>

          <div className="screen">
            {patientForm.updateEditButtonForExistingPatient && (
              <div className="screening-appointment">
                {/* <div className="medical-heading">
                    <p>
                      Has anything changed in your health since your last
                      appointment?
                    </p>
                  </div>
                  <div className="row">
                    <div className="radio-group ">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="AnythingChangeInHealthYourLastAppointment"
                        id="AnythingChangeInHealthYourLastAppointment"
                      >
                        <FormControlLabel
                          onChange={handleChange}
                          value={true}
                          control={
                            <Radio
                              checked={
                                formData[
                                  "AnythingChangeInHealthYourLastAppointment"
                                ] === null
                                  ? false
                                  : formData[
                                      "AnythingChangeInHealthYourLastAppointment"
                                    ]
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Yes"
                          className="mr-4"
                        />
                        <FormControlLabel
                          onChange={handleChange}
                          value={false}
                          control={
                            <Radio
                              checked={
                                formData[
                                  "AnythingChangeInHealthYourLastAppointment"
                                ] === null
                                  ? false
                                  : !formData[
                                      "AnythingChangeInHealthYourLastAppointment"
                                    ]
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="No"
                        />
                      </RadioGroup>
                    </div> 
                  </div>

                  <div className="medical-heading">
                    <p>Has your insurance changed since the last appointment?</p>
                  </div>
                  <div className="row">
                    {/* <div className="radio-group">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="InsuranceChangeSinceLastAppointment"
                        id="InsuranceChangeSinceLastAppointment"
                      >
                        <FormControlLabel
                          onChange={handleChange}
                          value={true}
                          control={
                            <Radio
                              checked={
                                formData[
                                  "InsuranceChangeSinceLastAppointment"
                                ] === null
                                  ? false
                                  : formData[
                                      "InsuranceChangeSinceLastAppointment"
                                    ]
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Yes"
                          className="mr-4"
                        />
                        <FormControlLabel
                          onChange={handleChange}
                          value={false}
                          control={
                            <Radio
                              checked={
                                formData[
                                  "InsuranceChangeSinceLastAppointment"
                                ] === null
                                  ? false
                                  : !formData[
                                      "InsuranceChangeSinceLastAppointment"
                                    ]
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="No"
                        />
                      </RadioGroup>
                    </div>
                  </div> */}
              </div>
            )}

            {(Object.keys(patientForm.validationResponse).length !== 0 &&
              !patientForm.validationResponse.preRegistrationComplete) ||
            Object.keys(patientForm.newPatientValidation).length !== 0 ? (
              <>
                <div className="screening-container-alignment d-flex align-items-start mb-3">
                  <Checkbox
                    value={true}
                    name="checkbox1"
                    onChange={handleCheckbox}
                    className="tnc-checkbox mr-1"
                    id="tnc-checkbox"
                    checked={
                      formData["checkbox1"] === null
                        ? false
                        : formData["checkbox1"]
                          ? true
                          : false
                    }
                  ></Checkbox>
                  <span className="screening-checkbox">
                    {_resources.Signature.I_AGREE_TO_THE}{" "}
                    <a
                      rel="noreferrer"
                      id="terms-conditions"
                      onClick={() => setReceiptAcknowledgement(true)}
                      className="color-blue"
                    >
                      {_resources.Signature.ACK_OF_RECEIPT}
                    </a>{" "}
                    {_resources.Signature.AND_THE}{" "}
                    <a
                      rel="noreferrer"
                      id="privacy-policy"
                      className="color-blue"
                      onClick={() => setTreatmentAcknowledgement(true)}
                    >
                      {_resources.Signature.AUTH_CONSENT}
                    </a>
                    <Modal
                      visible={receiptAcknowledgement}
                      className="exception-modal"
                      onCancel={() => setReceiptAcknowledgement(false)}
                      // onOk={() => setApiCallOnArrow(false)}
                      footer={null}
                      // size="large"
                      centered
                    >
                      <div className="modal-content">
                        <span
                          className="pop-up-modal-text"
                          dangerouslySetInnerHTML={{
                            __html: privacyReleaseText,
                          }}
                        />
                      </div>
                    </Modal>
                    <Modal
                      visible={treatmentAcknowledgement}
                      className="exception-modal"
                      onCancel={() => setTreatmentAcknowledgement(false)}
                      // onOk={() => setApiCallOnArrow(false)}
                      footer={null}
                      // size="large"
                      centered
                    >
                      <div className="modal-content">
                        <span
                          className="pop-up-modal-text"
                          dangerouslySetInnerHTML={{ __html: authConsentText }}
                        />
                      </div>
                    </Modal>
                  </span>
                </div>

                <div className="d-flex align-items-start mb-3">
                  <Checkbox
                    className="tnc-checkbox mr-1"
                    id="tnc-checkbox"
                    value="checkbox2"
                    name="checkbox2"
                    onChange={handleCheckbox}
                    checked={
                      formData["checkbox2"] === null
                        ? false
                        : formData["checkbox2"]
                          ? true
                          : false
                    }
                    // onClick={() => setBookButtonState(!bookButtonState)}
                  ></Checkbox>
                  <span className="screening-checkbox">
                    {_resources.Signature.I_AGREE_TO_THE}{" "}
                    <a
                      rel="noreferrer"
                      id="terms-conditions"
                      onClick={() => setActionAcknowledgement(true)}
                      className="color-blue"
                    >
                      {_resources.Signature.CAUSE_OF_ACTION}{" "}
                    </a>
                    {_resources.Signature.AND}{" "}
                    <a
                      rel="noreferrer"
                      id="terms-conditions"
                      onClick={() => setFinancialAcknowledgement(true)}
                      className="color-blue"
                    >
                      {_resources.Signature.FINANCIAL_RESP}{" "}
                    </a>
                    <Modal
                      visible={actionAcknowledgement}
                      className="exception-modal"
                      onCancel={() => setActionAcknowledgement(false)}
                      // onOk={() => setApiCallOnArrow(false)}
                      footer={null}
                      // size="large"
                      centered
                    >
                      <div className="modal-content">
                        <span
                          className="pop-up-modal-text"
                          dangerouslySetInnerHTML={{ __html: causeActionText }}
                        />
                      </div>
                    </Modal>
                    <Modal
                      visible={financialAcknowledgement}
                      className="exception-modal"
                      onCancel={() => setFinancialAcknowledgement(false)}
                      // onOk={() => setApiCallOnArrow(false)}
                      footer={null}
                      // size="large"
                      centered
                    >
                      <div className="modal-content">
                        <span
                          className="pop-up-modal-text"
                          dangerouslySetInnerHTML={{ __html: financeResText }}
                        />
                      </div>
                    </Modal>
                  </span>
                </div>

                <div className="d-flex align-items-start mb-3">
                  <Checkbox
                    value="checkbox3"
                    name="checkbox3"
                    onChange={handleCheckbox}
                    className="tnc-checkbox mr-1"
                    id="tnc-checkbox"
                    checked={
                      formData["checkbox3"] === null
                        ? false
                        : formData["checkbox3"]
                          ? true
                          : false
                    }
                    // onClick={() => setBookButtonState(!bookButtonState)}
                  ></Checkbox>
                  <span className="screening-checkbox">
                    {_resources.Signature.I_AGREE_TO_THE}{" "}
                    <a
                      // href="https://www.coraphysicaltherapy.com/terms-of-use/"
                      rel="noreferrer"
                      id="terms-use"
                      onClick={() => setTermsCon(true)}
                      className="color-blue"
                    >
                      {_resources.Signature.T_AND_C}{" "}
                    </a>
                    <Modal
                      visible={termsCons}
                      className="exception-modal"
                      onCancel={() => setTermsCon(false)}
                      // onOk={() => setApiCallOnArrow(false)}
                      footer={null}
                      // size="large"
                      centered
                    >
                      <div className="modal-content">
                        <span
                          className="pop-up-modal-text"
                          dangerouslySetInnerHTML={{ __html: termsConText }}
                        />
                      </div>
                    </Modal>
                    {_resources.Signature.AND_THE}{" "}
                    <a
                      rel="noreferrer"
                      id="privacy-use"
                      onClick={() => setPrivacyPol(true)}
                      className="color-blue"
                    >
                      {_resources.Signature.PRIVACY_POLICY}
                    </a>
                    <Modal
                      visible={privacyPol}
                      className="exception-modal"
                      onCancel={() => setPrivacyPol(false)}
                      // onOk={() => setApiCallOnArrow(false)}
                      footer={null}
                      // size="large"
                      centered
                    >
                      <div className="modal-content">
                        <span
                          className="pop-up-modal-text"
                          dangerouslySetInnerHTML={{
                            __html: privacyPolicyText,
                          }}
                        />
                      </div>
                    </Modal>
                  </span>
                </div>
              </>
            ) : null}

            <Button
              className={`dual-book-button continue-btn ${isDisabled ? 'Mui-disabled' : 'test'}`}
              onClick={handleClick}
              variant="contained"
              color="primary"
              type="submit"
              size="large"
              disabled={isDisabled}
            >
              {updatePatientSpinner && <Spin indicator={antIcon} className="mr-3 submit-btn-loader" />}
              {_resources.Signature.SUBMIT}
            </Button>

            <Button
              size="large"
              id="back-btn"
              onClick={goBack}
              className="dual-book-button back-button"
              variant="contained"
            >
              {_resources.Signature.BACK}
            </Button>
          </div>
        </div>
        <div className="col-lg-5 p-0 carousel-column">{renderCarousel()}</div>
      </div>
    </>
  );
};

export default Signature;
